import { pages } from '../menu'

const footers = [
	{ path: pages.login.path, element: null, exact: true },
	{ path: pages.otp.path, element: null, exact: true },
]

export default footers
